import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export const devFeatureGuard = (): CanActivateFn => (): true | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return (
    auth.$context().deploymentEnvironment === 'local' ||
    auth.$context().deploymentEnvironment === 'dev' ||
    router.parseUrl('/page-not-found')
  );
};
